import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { adminPath } from "@/lib/adminBase";

export default function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-rose-600" />
      </div>
    );
  }
  if (!user) return admin
    ? <Navigate to={adminPath("login")} replace />
    : <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (admin) {
    const hasAdminAccess = user.role === "admin" || user.is_super_admin ||
      (user.role === "counselor" && (user.role_id || (user.custom_permissions && Object.keys(user.custom_permissions).length > 0)));
    if (!hasAdminAccess) return <Navigate to="/dashboard" replace />;
  }
  return children;
}
